import { render, staticRenderFns } from "./wtColorPicker.component.vue?vue&type=template&id=7d0db92f&"
import script from "./wtColorPicker.component.vue?vue&type=script&lang=js&"
export * from "./wtColorPicker.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports